import type { FileNavigation, FolderNavigation } from '@teams/common/api/types'

interface Navigation {
  content: Array<{
    key: string
    value: string
  }>
  icon: string
  kind: string
  name: string
  pos: number
}

export function extractAvatarTitleByGroupName(name: string) {
  const chars: string[] = []
  const rules = [
    {
      reg: /[\u4e00-\u9fa5]/, // 中文
      value: 2
    },
    {
      reg: /[a-zA-Z]/,
      value: 1
    },
    {
      reg: /[0-9]/,
      value: 1
    }
  ]

  let value = 0
  let index = 0
  const charmaxLength = 4
  while (index < name.length && chars.length <= charmaxLength) {
    const char = name.charAt(index)
    const matched = rules.find(rule => rule.reg.test(char))
    if (matched && value + matched.value <= charmaxLength) {
      chars.push(char)
      value += matched.value
    }
    index++
  }

  return chars.join('')
}

export function processNavs(navs: Navigation[]) {
  return navs
    .map(nav => {
      switch (nav.kind) {
        case 'folder': {
          const fid = nav.content.find(item => item.key === 'fid')?.value || '0'
          return {
            ...nav,
            content: [
              { key: 'fid', value: `{{newfile ${fid}}}` },
              { key: 'companyId', value: '{{newcompany}}' },
              { key: 'groupId', value: '{{newgroup}}' }
            ]
          } as FolderNavigation
        }
        case 'file': {
          const fid = nav.content.find(item => item.key === 'fid')?.value
          const ext = nav.content.find(item => item.key === 'ext')?.value
          return {
            ...nav,
            content: [
              { key: 'fid', value: `{{newfile ${fid}}}` },
              { key: 'linkId', value: `{{newfilelink ${fid}}}` },
              { key: 'ext', value: ext || '' }
            ]
          } as FileNavigation
        }
        default: {
          return null
        }
      }
    })
    .filter(item => !!item) as Array<FolderNavigation | FileNavigation>
}
